module.exports = __webpack_public_path__ + "assets/img/alipay.99af01a3.svg";